// We are replacing this with rollup
const packageVersion = "__packageVersion__" as string;

export const version = packageVersion === "0.0.0" ? "UNRELEASED" : packageVersion;
